/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { useLocation } from "react-router-dom";

// SidebarCard promo removed
import routes from "routes";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const location = useLocation();
  const isUserPanel = location.pathname.startsWith("/user");
  return (
    <div
      className={`fixed left-0 top-0 z-50 flex h-full w-72 transform flex-col bg-white pb-10 shadow-2xl transition-transform dark:!bg-navy-800 dark:text-white ${
        open ? "translate-x-0" : "-translate-x-72"
      } xl:translate-x-0`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-4 mt-4 flex items-center xl:mx-6 xl:mt-6`}>
        <div className="ml-0 mt-0 font-poppins text-[20px] font-bold uppercase text-navy-700 dark:text-white">
          <span className="font-bold">NAC</span>
        </div>
        {isUserPanel ? (
          <span className="ml-3 inline-flex items-center gap-2 rounded-full bg-indigo-500 px-2 py-0.5 text-xs font-semibold text-white">
            <svg
              width="6"
              height="6"
              viewBox="0 0 6 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="inline-block"
            >
              <circle cx="3" cy="3" r="3" fill="white" />
            </svg>
            User
          </span>
        ) : null}
      </div>
      <div className="mb-4 mt-3 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto flex-1 overflow-y-auto pr-2 pt-1">
        <Links routes={routes} />
      </ul>

      {/* promo removed */}

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
